module.exports = __webpack_public_path__ + "static/media/dna_kit_n_reports.cc7ae734.png";